import React from "react";
import { Box } from "../Box/Box";
import styles from "./Divider.module.css";

export interface DividerProps {
  weight?: "light" | "regular" | "strong";
}

const defaultWeight = "regular";
export const Divider = ({
  weight = defaultWeight,
}: DividerProps): React.ReactElement => {
  return (
    <Box position="relative">
      <Box
        position="absolute"
        width="full"
        className={[
          styles.base,
          styles[`weight-${weight}`] || styles[`weight-${defaultWeight}`],
        ]}
      />
    </Box>
  );
};
